/* eslint-disable @typescript-eslint/default-param-last */
import { IApiCallStatusAction } from "@/types/apiCallStatus.types";
import {
  END_INTERVIEW_FOR_ALL,
  LEAVE_INTERVIEW,
  MOVE_CANDIDATE_TO_LOBBY,
  UPDATE_API_CALL_STATUS,
} from "@/constants/ActionTypes";
import { USER_STATUS_API } from "@/constants/ApiNameConstants";
import initialState from "@/store/initialState";

const apiCallStatusReducer = (
  state = initialState.apiCallStatus,
  action: IApiCallStatusAction,
) => {
  switch (action.type) {
    case UPDATE_API_CALL_STATUS:
      return { ...state, [action.payload.apiName]: action.payload.status };
    case `${LEAVE_INTERVIEW}_SUCCESS`:
    case `${MOVE_CANDIDATE_TO_LOBBY}_SUCCESS`:
    case `${END_INTERVIEW_FOR_ALL}_SUCCESS`:
      return { ...state, [USER_STATUS_API]: state.USER_STATUS_API };
    default:
      return state;
  }
};

export default apiCallStatusReducer;
